module.exports = BVConfigs.footer;